import {
  label_default
} from "./chunk-AWEODRKT.js";

// src/blocks/show-run-label/show-run-label.tsx
import { format } from "date-fns";
import { jsx } from "react/jsx-runtime";
var ShowRunLabel = ({
  className,
  endDate,
  id,
  labels = {
    showingFrom: "Showing from",
    showingOngoing: "Ongoing"
  },
  startDate
}) => {
  const showRunData = {
    endMonth: endDate !== void 0 ? format(endDate?.local, "MMMM") : "NoEndMonthSet",
    endYear: endDate !== void 0 ? format(endDate?.local, "yyyy") : "NoEndYearSet",
    startMonth: startDate !== void 0 ? format(startDate?.local, "MMMM") : "NoStartMonthSet",
    startYear: startDate !== void 0 ? format(startDate?.local, "yyyy") : "NoStartYearSet"
  };
  const showRunState = {
    hasSameMonthYear: showRunData?.startMonth === showRunData?.endMonth && showRunData?.startYear === showRunData?.endYear,
    hasSameYearOnly: showRunData?.startMonth !== showRunData?.endMonth && showRunData?.startYear === showRunData?.endYear,
    hasDifferentYear: showRunData?.startYear !== showRunData?.endYear
  };
  let showRunAsLabel = `${labels?.showingFrom} ${showRunData.startMonth} ${showRunData.startYear}`;
  if (showRunState.hasSameMonthYear) {
    showRunAsLabel = `${showRunData.startMonth} ${showRunData.startYear}`;
  }
  if (showRunState.hasSameYearOnly) {
    showRunAsLabel = `${showRunData.startMonth}\u2014${showRunData.endMonth}, ${showRunData.endYear}`;
  }
  if (showRunState.hasDifferentYear) {
    showRunAsLabel = `${showRunData.startMonth} ${showRunData.startYear}\u2014${showRunData.endMonth} ${showRunData.endYear}`;
  }
  return /* @__PURE__ */ jsx(label_default, { className, id, text: showRunAsLabel });
};
var show_run_label_default = ShowRunLabel;

export {
  show_run_label_default
};
